import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'ceres-beta',
    templateUrl: './beta.component.html',
    styleUrls: ['./beta.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BetaComponent {}
